import { useTranslation } from 'react-i18next'
import PerText from '../../../components/custom_components/Text'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import AppraisalFooter from '../../../components/custom_components/Appraisal/AppraisalFooter'
import { ScoreGridDto, ScoreGoalDto, FullMeetingFragment, Country } from '../../../types'
import { AppraisalContextType } from '../AppraisalTypes'
import { areScoreGoalsEquals, allScoreGoalsExist, mapGoalsToInput } from './EvaluationUtil'
import PerButtonCircle from '../../../components/custom_components/ButtonCircle'
import { saveScoreGridWithRefetch } from '../../../graphql/score-grid/hooks/useSaveScoreGrid'

export const EvaluationFooterComponent = ({
  meeting,
  isIdVWeightEnabled,
  evaluationScore,
  employeeName,
  employeePreparationPublic = false,
  currentGrid,
  goalsState,
  showFooter,
  type,
}: {
  meeting: FullMeetingFragment
  isIdVWeightEnabled: boolean
  evaluationScore?: number | null
  employeeName?: string
  employeePreparationPublic?: boolean
  currentGrid: ScoreGridDto
  goalsState: ScoreGoalDto[]
  showFooter: boolean
  type: AppraisalContextType
}): JSX.Element => {
  const [t] = useTranslation()
  const hasValidEmployeeScore = employeeName && !!currentGrid.employeePreparationScore && employeePreparationPublic

  return (
    <>
      {showFooter && (
        <AppraisalFooter>
          <PerFlexRow>
            <div>
              {!!currentGrid.lastResultScore && (
                <PerText appearance="footer-label-small">{t('appraisalMeeting.evaluation.footer.lastScore')}</PerText>
              )}
              {hasValidEmployeeScore && (
                <PerText appearance="footer-label-small">
                  {t('appraisalMeeting.evaluation.footer.employeeScore', { name: employeeName })}
                </PerText>
              )}
            </div>

            <div>
              {currentGrid.lastResultScore && (
                <PerText appearance="footer-input-small">&nbsp; {currentGrid.lastResultScore.toFixed(2)}</PerText>
              )}
              {hasValidEmployeeScore && (
                <PerText appearance="footer-input-small">&nbsp; {currentGrid.employeePreparationScore!.toFixed(2)}</PerText>
              )}
            </div>
          </PerFlexRow>

          {isIdVWeightEnabled && (evaluationScore || allScoreGoalsExist(goalsState, type)) && (
            <PerFlexRow align="middle">
              <PerText appearance="footer-label">{t('appraisalMeeting.evaluation.footer.evaluationScore')}</PerText>
              {evaluationScore && areScoreGoalsEquals(goalsState, currentGrid.scoreGoals, type) ? (
                <PerText appearance="footer-input">&nbsp; {evaluationScore.toFixed(2)}</PerText>
              ) : (
                <PerButtonCircle
                  tooltip={t('appraisalMeeting.evaluation.footer.evaluationScoreTooltip')}
                  icon="notes_fill"
                  color="primary"
                  variant="pastel"
                  onClick={async () => {
                    currentGrid.scoreGoals = mapGoalsToInput(goalsState)
                    await saveScoreGridWithRefetch(meeting.id, currentGrid, meeting.employee.id, meeting.appraisalSeason.country as Country)
                  }}
                />
              )}
            </PerFlexRow>
          )}
        </AppraisalFooter>
      )}
    </>
  )
}
